export default __webpack_public_path__ + "static/media/logo.9219e289.png";